import React from 'react'
import { FaRegCheckCircle } from 'react-icons/fa'
import { MdOutlineErrorOutline } from 'react-icons/md'
import './InputStatusIcon.scss'

export const InputStatusIcon: React.FC<{
  errorsExist?: boolean
  inputEntered: boolean
}> = ({ inputEntered, errorsExist }) => {
  const className = 'input-status-icon'
  const extraClassName = errorsExist
    ? `${className}--error`
    : inputEntered
    ? `${className}--success`
    : ''
  const icon = errorsExist ? (
    <MdOutlineErrorOutline />
  ) : inputEntered ? (
    <FaRegCheckCircle />
  ) : null
  return (
    <div className={className + (extraClassName ? ' ' + extraClassName : '')}>
      {icon}
    </div>
  )
}
